import React from 'react';
import { cn } from '@/lib/utils';

interface RangeFilterProps {
    label: string;
    minValue?: number;
    maxValue?: number;
    onChange: (type: 'min' | 'max', value: number) => void;
    minPlaceholder?: string;
    maxPlaceholder?: string;
    step?: number;
    symbol?: string;
    hideLabel?: boolean;
}

export function RangeFilter({
        label,
        minValue,
        maxValue,
        onChange,
        minPlaceholder = "От",
        maxPlaceholder = "До",
        step = 1,
        symbol,
        hideLabel = false
    }: RangeFilterProps) {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, type: 'min' | 'max') => {
        // Treat empty string as 0, otherwise parse float
        const val = e.target.value === '' ? 0 : parseFloat(e.target.value);
        onChange(type, isNaN(val) ? 0 : val);
    };

    const inputClassName = "w-full rounded bg-zinc-900 border border-zinc-800 px-3 py-2 text-sm text-white focus:border-brand-gold focus:outline-none transition-colors placeholder-zinc-600 no-spinner";

    return (
        <div className={cn("flex flex-col", !hideLabel ? "px-4 py-5 space-y-4" : "px-4 py-4")}>
            {!hideLabel && (
                <div className="flex justify-between items-center">
                    <h3 className="text-sm font-bold text-zinc-100 uppercase tracking-wider">{label}</h3>
                    {symbol && <span className="text-xs text-zinc-500 font-medium">{symbol}</span>}
                </div>
            )}

            <div className="flex items-center gap-2">
                <div className="relative w-full">
                    <input
                        type="number"
                        value={minValue || ''}
                        onChange={(e) => handleChange(e, 'min')}
                        step={step}
                        className={inputClassName}
                        placeholder={minPlaceholder}
                    />
                </div>
                <span className="text-zinc-500 font-medium">-</span>
                <div className="relative w-full">
                    <input
                        type="number"
                        value={maxValue || ''}
                        onChange={(e) => handleChange(e, 'max')}
                        step={step}
                        className={inputClassName}
                        placeholder={maxPlaceholder}
                    />
                </div>
                {hideLabel && symbol && (
                    <span className="text-md text-zinc-500  uppercase tracking-wider shrink-0 ml-1">
            {symbol}
          </span>
                )}
            </div>
        </div>
    );
}
